/**
 * User Entity
 * Representa un usuario en el dominio
 * Esta entidad es independiente de cualquier framework o librería
 */
export class User {
  constructor(
    public readonly id: string,
    public readonly email: string,
    public readonly role: 'superadmin' | 'admin' | 'backupmanager',
    public readonly name?: string,
    public readonly photoUrl?: string,
    public readonly organizationSlug?: string,
    public readonly surname?: string,
    public readonly secondSurname?: string,
    public readonly status: 'active' | 'inactive' = 'active',
    public readonly organizationName?: string,
    public readonly intercomHash?: string,
    public readonly createdAt?: number,
    public readonly userId?: string,
  ) {}

  /**
   * Valida si el usuario tiene rol de administrador
   */
  isAdmin(): boolean {
    return this.role === 'admin';
  }

  /**
   * Obtiene el nombre a mostrar del usuario
   * Si no tiene nombre, usa el email
   */
  getDisplayName(): string {
    return [this.name, this.surname, this.secondSurname].filter(Boolean).join(' ') || this.email.split('@')[0];
  }

  /**
   * Crea una instancia de User desde datos primitivos
   */
  static fromPrimitives(data: {
    id: string;
    email: string;
    role: 'superadmin' | 'admin' | 'backupmanager';
    name?: string;
    photoUrl?: string;
    organizationSlug?: string;
    surname?: string;
    secondSurname?: string;
    status?: 'active' | 'inactive';
    organizationName?: string;
    intercomHash?: string;
    createdAt?: number;
    userId?: string;
  }): User {
    return new User(data.id, data.email, data.role, data.name, data.photoUrl, data.organizationSlug, data.surname, data.secondSurname, data.status ?? 'active', data.organizationName, data.intercomHash, data.createdAt, data.userId);
  }

  /**
   * Convierte el User a datos primitivos
   */
  toPrimitives(): {
    id: string;
    email: string;
    role: 'superadmin' | 'admin' | 'backupmanager';
    name?: string;
    photoUrl?: string;
    organizationSlug?: string;
    surname?: string;
    secondSurname?: string;
    status: 'active' | 'inactive';
    organizationName?: string;
    intercomHash?: string;
    createdAt?: number;
    userId?: string;
  } {
    return {
      id: this.id,
      email: this.email,
      role: this.role,
      name: this.name,
      photoUrl: this.photoUrl,
      organizationSlug: this.organizationSlug,
      surname: this.surname,
      secondSurname: this.secondSurname,
      status: this.status,
      organizationName: this.organizationName,
      intercomHash: this.intercomHash,
      createdAt: this.createdAt,
      userId: this.userId,
    };
  }
}
